module.exports = __webpack_public_path__ + "img/bx-export.f3537d2c.svg";